export default {
  componentsPrefix: "navTab-"
}